import api from "./api";

// 新增活动
export const addRunningActivity = params => {
  return api('post', `/v1/management/running/add-activity`, params);
};

// 删除活动
export const delRunningActivity = id => {
  return api('delete', `/v1/management/running/del-activity/${id}`);
};

// running活动详情
export const detailRunningActivity = id => {
  return api('get', `/v1/management/running/detail/${id}`);
};

// 编辑活动
export const editRunningActivity = params => {
  return api('post', `/v1/management/running/edit-activity`, params);
};

// 导出跑步记录
export const exportRunningActivity = (id) => {
  return api('get', `/v1/management/running/exportRunning/${id}`,
    {},
    {
      responseType: "blob",
    }
  )
}

// running活动列表展示
export const postRunningActivity = params => {
  return api('post', `/v1/management/running/list`, params);
};

// 下架活动
export const offlineRunningActivity = id => {
  return api('get', `/v1/management/running/offline-activities/${id}`);
};

// 发布活动
export const releaseRunningActivity = id => {
  return api('get', `/v1/management/running/release-activities/${id}`);
};

//显示中奖公示
export const runningShowLottery = id => {
  return api('get', `/v1/management/running/showLottery/${id}`)
}
